<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="resetPasswordForm">
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.email, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.email, 'label')">{{ 'EMAIL' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.email, 'borderInput')">
						<input type="text" pInputText
							[ngClass]="dynamicInputTextWidth()"
							id="email-reset-input"
							formControlName="email"
							placeholder="email@domain.com"
						/>
					</div>
				</div>
				<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
					<small *ngIf="showErrorRequiredMessage(this.f.email)" class="pt-1">{{ 'REQUIRED' | translate }}. {{ 'EMAIL_ADDRESS_INVALID' | translate }}</small>
				</div>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
					label="{{ 'CANCEL' | translate }}"
					class="p-button-secondary text-xl font-normal mt-2 mx-1"
					[ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>